
    import '/vercel/path0/docs/demo/with-portal.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"with-portal","toc":"menu","filename":"docs/demo/with-portal.md","lastUpdated":1770366105000,"nav":{"title":"Demo","path":"/demo"}};